import Vue from 'vue';
import type { IResource } from '@rready/sdk';
import { useAuthStore } from '../store/authStore';
import { useContextStore } from '../store/contextStore';

export const resourceMixin = Vue.extend({
  methods: {
    $res<T>(resource: IResource<T> | undefined, fallback?: T): T {
      if (!resource || Object.keys(resource).length === 0) {
        if (!fallback) {
          console.warn('IResource error: Resource cannot be undefined');
        }
        return fallback ?? undefined!;
      }

      const userLanguage = useAuthStore().user?.language ?? '';
      const orgLanguage =
        useContextStore().organization?.language.default ?? '';

      const metaDefaultLanguage = resource.defaultLanguage ?? 'en';
      const languages: string[] = [
        metaDefaultLanguage,
        orgLanguage,
        userLanguage
      ];
      const result = this.filterEmptyEntries(resource, languages);

      if (!Object.keys(result).length && !fallback) {
        console.warn(
          `IResource error: Could not find any suitable translation`,
          resource
        );
      }

      return (
        (Object.keys(result).length ? result : fallback) ??
        this.firstResource(resource)
      );
    },
    filterEmptyEntries(resource: IResource<any>, languages: string[]): any {
      return languages.reduce((acc, curr) => {
        const resourceContent = resource[curr];
        if (resourceContent) {
          Object.entries(resourceContent).forEach(([key, value]) => {
            if (value) {
              acc[key] = value;
            }
          });
        }
        return acc;
      }, {} as Record<string, unknown>);
    },
    firstResource(resource: IResource<any>): any {
      return Object.values(resource).find((value) => typeof value === 'object');
    }
  }
});
